const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

/** Resolve a media URL: backend-served uploads are relative, demo media are absolute. */
export function mediaSrc(url) {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${BACKEND}${url}`;
  return url;
}

export const TIMEZONE_LABEL = "Fuseau : Montréal (America/Toronto)";
